import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {GetCodeListResponse} from '../../metadaWarehouseCodeList/types';

const getWarehousePricingEnumsResponseMock: GetCodeListResponse = [
  {
    id: '130',
    category: 'WRH-WAREHOUSE-PRICING',
    code: 'AVG',
    name: 'Average',
    isDefault: false,
    isActive: true,
    dictionary: 'Stock pricing',
  },
  {
    id: '131',
    category: 'WRH-WAREHOUSE-PRICING',
    code: 'FIFO',
    name: 'FIFO',
    isDefault: false,
    isActive: true,
    dictionary: 'Stock pricing',
  },
];

const getWarehousePricingEnumsResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/warehouse/v1/codelist/WRH-WAREHOUSE-PRICING', () =>
      HttpResponse.json(getWarehousePricingEnumsResponseMock)
    )
  );

export const metadaWarehousePricingEnumsApiMock = {
  getWarehousePricingEnumsResponseMock,
  getWarehousePricingEnumsResponseInterceptor,
};
